import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  // Define aquí la URL de tu CDN
  private readonly CDN_BASE_URL = `${environment.cdnImgBaseUrl}icons/material-design-icons`;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  /**
   * Configura una estrategia global para que MatIcon busque automáticamente 
   * en la CDN si no encuentra el icono localmente, o registra un set común.
   */
  public initGlobalIcons() {
    // Opción A: Registrar un Set de iconos comunes que se usan en todo el proyecto
    const commonIcons = [
      { name: 'warning', path: 'two-tone/warning.svg' },
      { name: 'close', path: 'filled/close.svg' },
      { name: 'error', path: 'filled/error.svg' },
      { name: 'check_circle', path: 'filled/check_circle.svg' },
      { name: 'check', path: 'two-tone/check.svg' },
    ];

    // 2. Iconos con namespace 'mat' (para [svgIcon]="'mat:zoom_in'")
    const matNamespaceIcons = [
      { name: 'warning', path: 'two-tone/warning.svg' },
      { name: 'check', path: 'two-tone/check.svg' },
      { name: 'zoom_in', path: 'filled/zoom_in.svg' },
      { name: 'zoom_out', path: 'filled/zoom_out.svg' }
    ];

    matNamespaceIcons.forEach(icon => this.registerIconWithNamespace('mat', icon.name, icon.path));

    commonIcons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.CDN_BASE_URL}/${icon.path}`)
      );
    });

    // Nota: MatIconRegistry no tiene un "fallback" nativo por defecto para URLs dinámicas,
    // por lo que la lista anterior es la forma más segura.
  }

    /**
   * Registra un icono en un namespace específico.
   * Esto permite usar la sintaxis [svgIcon]="namespace:name"
   */
  public registerIconWithNamespace(namespace: string, name: string, path: string) {
    const url = `${this.CDN_BASE_URL}/${path}`;
    this.matIconRegistry.addSvgIconInNamespace(
      namespace,
      name,
      this.domSanitizer.bypassSecurityTrustResourceUrl(url)
    );
  }
}